import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import { Typography, Hidden } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { useStyles } from './style';
import { AdjustedSkeleton, StyledButton } from '../../../../../components';
import { useDetailPageBackButton } from '../../../../../shared/hooks';

interface HeaderProps {
	className?: string;
	partner?: object;
	loading?: boolean;
}

const Header = (props: HeaderProps) => {
	const { className, partner, loading } = props;
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const classes = useStyles();

	const returnButton = useDetailPageBackButton(location);

	const handleBackButtonChange = () => navigate('/partnerships/partners');

	return (
		<div className={clsx(classes.root, className)}>
			<Typography component='h2' gutterBottom variant='overline'>
				<Hidden only={['xs', 'sm']}>
					<StyledButton
						className={classes.backButton}
						onClick={handleBackButtonChange}
						startIcon={<KeyboardArrowLeftOutlinedIcon />}
						variant='inline-default'
					>
						{returnButton.isBackButton ?
							t('ui.button.inline.back')
						:	t('view.partnershipmanagement.button.inline.returntopartners')}
					</StyledButton>
				</Hidden>
			</Typography>
			<Typography component='h1' variant='h3'>
				{loading ?
					<AdjustedSkeleton animation='wave' width={200} />
				:	partner.partnerOrganisation.name}
			</Typography>
		</div>
	);
};

export default Header;
